import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';
import forwardButton from '../../../assets/buttons/forward.png';
import { remCalc } from '../../../util/style-util';
import { ButtonSize } from '../../../types';

type Props = ButtonBaseProps & {
  className?: any;
  size?: ButtonSize;
  style?: React.CSSProperties;
  components?: any;
  pulsing?: boolean;
};

export const NextButton: React.FC<Props> = ({
  size = ButtonSize.SMALL,
  onClick,
  style = {},
  className = '',
  components,
  pulsing = false,
  ...props
}) => {
  const classes = useStyles({ size });

  return (
    <>
      <ButtonBase
        key={'home'}
        className={`${classes.image} ${className} ${pulsing ? classes.pulsing : ''}`}
        onClick={onClick}
        style={{
          zIndex: 9999,
          position: 'absolute',
          bottom: '50%',
          transform: 'translateY(50%)',
          right: 20,
          animation: `$pulse 1.2s infinite`,
          ...style,
        }}
        {...props}
      />
      {components && <div>{components}</div>}
    </>
  );
};

export default NextButton;

const useStyles = makeStyles(() => {
  return {
    image: ({ size }: any) => ({
      backgroundImage: `url(${forwardButton})`,
      backgroundRepeat: 'no-repeat',
      backgroundOrigin: 'padding-box',
      backgroundSize: '100% 100%',
      width: remCalc(size),
      height: remCalc(size),
      cursor: 'pointer',
      zIndex: 9999,
      flexShrink: 0,
      '&:hover': {
        transform: 'scale(1.05, 1.05)',
      },
    }),
    pulsing: {
      animation: `$pulse 1.2s infinite`,
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'translateY(50%) scale(.90)',
      },
      '50%': {
        transform: 'translateY(50%) scale(1.2)',
      },
      '100%': {
        transform: 'translateY(50%) scale(.90)',
      },
    },
  };
});
